import { VL_API_BASE_URL } from '../constants/backendUrls';
import type { Role, RoleResponse, SaveRole, UpdateRoles } from '../types/roles';
import { APIClient } from './apiClient';

const baseUrl = `${VL_API_BASE_URL}/roles`;

export async function loadRoles ({ active }: { active?: boolean } = {}): Promise<RoleResponse> {
    const rolesData: RoleResponse = { count: 0, items: [], lastKey: '' };
    let res: RoleResponse;
    let url = baseUrl;

    do {
        res = await APIClient<RoleResponse>(url);
        rolesData.count += res.count;
        rolesData.items = [
            ...rolesData.items,
            ...(active === undefined
                ? res.items
                : res.items.filter(role => role.active === active))
        ];
        if (res?.lastKey) {
            url = `${baseUrl}?startKey=${res.lastKey}`;
        }
    } while (res.lastKey);

    rolesData.items
        .forEach((role) => {
            if (!role.permissions) {
                role.permissions = [];
            }
        });

    return rolesData;
}

export async function saveRole (roledata: Partial<SaveRole>) {
    return await APIClient<RoleResponse>(`${baseUrl}`, { method: 'POST', body: JSON.stringify(roledata) });
}

export async function updateRoles (data: Partial<UpdateRoles>) {
    return await APIClient<UpdateRoles>(`${baseUrl}`, { method: 'PUT', body: JSON.stringify(data) });
}

export async function deleteRole (roleId: string) {
    return await APIClient<Role>(`${baseUrl}/${roleId}`, { method: 'DELETE' });
}

// TODO: Refactor this to use loadRoles instead
export async function getRoles () {
    return await APIClient<RoleResponse>(baseUrl, { method: 'GET' });
}

// TODO: Refactor this to use saveRoles instead
export async function updateRole (data: Role) {
    const cleanData = Object.fromEntries(Object.entries(data).filter(([, v]) => v !== null));
    return await APIClient<Role>(baseUrl, { method: 'PUT', body: JSON.stringify(cleanData) });
}

export async function getRoleById (roleId: string) {
    return await APIClient<Role>(`${baseUrl}/${roleId}`);
}
